export const environmentData = {
  run: "development",
  development: {
    clientId: "e7908b58-b0a0-4062-9422-4fcfeaa189d5",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid e7908b58-b0a0-4062-9422-4fcfeaa189d5/User.Impersonation",

    apiBaseURL: "https://hm-trendyol-api-v8.azurewebsites.net/api",
  },
  staging: {
    clientId: "e7908b58-b0a0-4062-9422-4fcfeaa189d5",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid e7908b58-b0a0-4062-9422-4fcfeaa189d5/User.Impersonation",

    apiBaseURL: "https://hm-trendyol-api-v8.azurewebsites.net/api",
  },
  production: {
    clientId: "e7908b58-b0a0-4062-9422-4fcfeaa189d5",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid e7908b58-b0a0-4062-9422-4fcfeaa189d5/User.Impersonation",

    apiBaseURL: "https://hm-trendyol-api-v8.azurewebsites.net/api",
  },
};
